var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpgradeNovaburner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 142.43 75.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e19aed;\n      }\n\n      .cls-2 {\n        fill: #e7b6f2;\n      }\n\n      .cls-3 {\n        fill: #c992d6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "142.43 56.76 116.76 75.26 116.76 0 142.43 18.49 142.43 56.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "116.76 75.26 42.68 56.03 58.12 49.29 0 38.48 0 36.78 58.12 25.97 40.59 19.79 116.76 0 116.76 75.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "116.76 52.11 73.38 39.61 73.38 36.22 116.76 23.71 116.76 52.11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeNovaburner);
export default __webpack_public_path__ + "static/media/upgrade-novaburner.aa7b7d08dc6169e8f6f9fcd301ee4cbd.svg";
export { ForwardRef as ReactComponent };